<template lang="pug">
extends ../../../components/filter/dynamic-filter-template.pug

block item
    template(#receipts.drawer_session_id="props")
        div
            span.block {{ props.value.display_name }}
            small.text-muted(v-if="props.value.owner_outlets")
                | {{ props.value.outlet_name }} <br/>
            small.text-muted
                | {{ props.value.staff_name }}

    template(#receipts.day_operation_id="props")
        div
            span.block {{ props.value.display_name }}
            small.text-muted(v-if="props.value.owner_outlets")
                | {{ props.value.outlet_name }}
                br

            small.text-muted
                | {{ props.value.staff_name }}

    template(#receipt_payments.payment_id="props")
        div
            span.block {{ props.value.display_name }}
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import dynamicFilterBase from '@js/components/filter/dynamic-filter-base';
import tillFilterMixin from '@js/components/till-filter/till-filter-mixin';

export default {
    extends: dynamicFilterBase,

    mixins: [tillFilterMixin],

    props: {
        storeModule: {
            type: String,
            default: 'subsidyReimbursementReport',
        },
        hidePayment: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        let that = this;

        return {
            preSelectOperator: true,
            returnOperatorValueList: true,
            externalRemotes: this.hidePayment
                ? {}
                : {
                      payment(query) {
                          return that
                              .getPaymentListIfNecessary({ query })
                              .then(data => {
                                  return data.map(d => ({
                                      id: d.id,
                                      display_name: d.name,
                                  }));
                              });
                      },
                  },
        };
    },

    computed: {
        ...mapGetters(['activeOutlet', 'startDate', 'endDate']),

        filters() {
            return this.$store.state[this.storeModule].filters;
        },

        searchMeta() {
            return this.$store.state[this.storeModule].searchMeta;
        },

        loading() {
            return this.onLoading('get-meta');
        },
    },

    created() {
        this.$store.dispatch(`${this.storeModule}/getSearchMetaIfNecessary`);
        if (!this.hidePayment) {
            this.getPaymentListIfNecessary();
        }
    },

    methods: {
        setFilters(filters) {
            this.$store.commit(`${this.storeModule}/setFilters`, filters);
        },

        ...mapActions('payment', ['getPaymentListIfNecessary']),
    },
};
</script>
